module.exports = __webpack_public_path__ + "static/media/key-csm.2cce02d9.png";